import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import Pagination from "../../Pagination";

const GlobalSettingsHRByAdmin = () => {
    const BASE_API_URL = process.env.REACT_APP_API_URL;

    const [globalSettings, setGlobalSettings] = useState([]);
    // Pagination & Sorting
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [totalPages, setTotalPages] = useState(0);
    const [sortedColumn, setSortedColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState('asc');
    const isLastPage = page === totalPages - 1;
    const isPageSizeDisabled = isLastPage;

    const [showModal, setShowModal] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [additionalSpace, setAdditionalSpace] = useState(0);
    const [utilizedSpace, setUtilizedSpace] = useState(0);
    const [totalSpace, setTotalSpace] = useState(5); // Default 5GB

    useEffect(() => {
        fetchGlobalSettings();
    }, [page, pageSize, sortOrder, sortedColumn]);
    const fetchGlobalSettings = async () => {
        try {
            const response = await axios.get(`${BASE_API_URL}/companiesGlobalSettings`, {
                params: {
                    page,
                    size: pageSize,
                    sortBy: sortedColumn,
                    sortOrder: sortOrder,
                }
            });
            setGlobalSettings(response.data.content);
            setTotalPages(response.data.totalPages); // Update totalPages for pagination
        } catch (error) {
            console.error('Error fetching global settings:', error);
        }
    };

    const handlePageClick = (data) => {
        setPage(data.selected);
    };
    const handlePageSizeChange = (e) => {
        const size = parseInt(e.target.value);
        setPageSize(size);
        setPage(0); // Reset page when page size changes
    };

    const handleSort = (column) => {
        if (sortedColumn === column) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortedColumn(column);
            setSortOrder('asc');
        }
    };

    const handleSaveChanges = async () => {
        try {
            await axios.put(`${BASE_API_URL}/updateAdditionalCredit`, null, {
                params: {
                    companyName: selectedCompany.companyName,
                    additionalCreditSpace: additionalSpace // in GB directly
                }
            });

            setShowModal(false);
            fetchGlobalSettings(); // reload updated data

        } catch (error) {
            console.error('Error updating additional credit space:', error);
        }
    };


    const handleAdditionalSpaceChange = (value) => {
        if (/^\d*$/.test(value)) {
            const newAdditionalSpace = value === '' ? 0 : parseInt(value, 10);
            setAdditionalSpace(newAdditionalSpace);
            // Update total space (5GB + additional space in GB)
            setTotalSpace(5 + newAdditionalSpace);
        }
    };

    const handleOpenModal = (setting) => {
        setSelectedCompany(setting);
        // Convert MB to GB for additional space
        setAdditionalSpace((setting.additionalCreditSpace || 0));
        setUtilizedSpace(setting.utilizedSpace || 0);
        setTotalSpace(5 + ((setting.additionalCreditSpace || 0)));
        setShowModal(true);
    };

   

    return (
        <>
            <div>
                <div>
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th onClick={() => handleSort('companyName')}>
                                    Company Name {sortedColumn === 'companyName' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </th>
                                <th onClick={() => handleSort('JobBoxId')}>
                                    JobBoxId {sortedColumn === 'JobBoxId' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </th>
                                <th onClick={() => handleSort('defalut space')}>
                                    Total Space {sortedColumn === 'defalut space' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </th>
                                <th onClick={() => handleSort('Utilization space')}>
                                    Utilization space{sortedColumn === 'Utilization space' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </th>
                                <th>Add Additional</th>
                            </tr>
                        </thead>
                        <tbody>
                            {globalSettings.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="text-center">No data found</td>
                                </tr>
                            ) : (
                                globalSettings.map((setting, index) => (
                                    <tr key={index}>
                                        <td>{setting.companyName}</td>
                                        <td>{setting.jobboxEmail}</td>
                                        <td>{(5 + parseFloat(setting.additionalCreditSpace || 0)).toFixed(1)} GB</td>

                                        <td>{setting.utilizedSpace}</td>
                                        <td>
                                            <Button
                                                className="btn btn-sm btn-primary"
                                                onClick={() => handleOpenModal(setting)}
                                            >
                                                Add
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
                <Pagination
                    page={page}
                    pageSize={pageSize}
                    totalPages={totalPages}
                    handlePageSizeChange={handlePageSizeChange}
                    isPageSizeDisabled={isPageSizeDisabled}
                    handlePageClick={handlePageClick}
                />
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Additional Credits for {selectedCompany?.companyName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table bordered>
                        <tbody>
                            <tr>
                                <th>Default Space (GB)</th>
                                <td>
                                    <Form.Control value="5" readOnly plaintext />
                                </td>
                            </tr>
                            <tr>
                                <th>Additional Credit Space (GB)</th>
                                <td>
                                    <Form.Control
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        placeholder="Numbers only"
                                        value={additionalSpace || ''}
                                        onChange={(e) => handleAdditionalSpaceChange(e.target.value)}
                                        onPaste={(e) => {
                                            if (!/^\d+$/.test(e.clipboardData.getData('Text'))) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>Total Space (GB)</th>
                                <td>
                                    <Form.Control value={totalSpace.toFixed(1)} readOnly plaintext />
                                </td>
                            </tr>
                            <tr>
                                <th>Current Utilization Space (MB)</th>
                                <td>
                                    <Form.Control value={`${selectedCompany?.utilizedSpace || 0} MB`} readOnly plaintext />
                                </td>
                            </tr>

                        </tbody>
                    </Table>
                    <p className="mt-3 fw-bold">Total Utilization space: {selectedCompany?.utilizedSpace || 0} MB / {totalSpace.toFixed(1)} GB</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
                    <Button variant="primary" onClick={handleSaveChanges}>Save Changes</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default GlobalSettingsHRByAdmin
